import { $, isMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lateral-sticky]')) return;

  addEventListeners();
}

function checkVisibilityLateralSticky() {
  const fullStickyModule = $('[data-au-lateral-sticky]');
  const lateralStickyButton = $('[data-au-lateral-sticky-button]');
  const lateralStickyContent = $('[data-au-lateral-sticky-content]');
  const a = isMobile.matches ? 0 : lateralStickyContent.scrollHeight - lateralStickyButton.scrollHeight;
  const footer = $('footer');
  const footerPos = footer ? footer.getBoundingClientRect() : 0;

  if (footerPos.top <= window.innerHeight - a && footerPos.bottom >= 0) {
    fullStickyModule.classList.add('au-full-sticky__hide');
  } else {
    fullStickyModule.classList.remove('au-full-sticky__hide');
  }
}

function toggleLateralSticky(e) {
  const lateralSticky = $('[data-au-lateral-sticky]');
  const lateralStickyButton = $('[data-au-lateral-sticky-button]');
  const lateralStickyIcon = lateralStickyButton.querySelector('[data-au-icon]');
  const lateralStickyLabel = removeAccentMarkAndUppercase(
    lateralStickyButton.querySelector('[data-au-lateral-sticky-label]').textContent,
  );
  e.preventDefault();

  // close on ESC
  if (e.type === 'keyup' && e.key === 'Escape') {
    lateralSticky.classList.remove('au-lateral-sticky--visible');
    lateralStickyIcon.textContent = 'phone';
    lateralStickyButton.setAttribute('aria-expanded', 'false');

    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickBoton',
      item_id: `sticky lateral_cerrar`,
    });
  } else if (e.type === 'click') {
    // click event

    // toggle visibility and icons
    lateralSticky.classList.toggle('au-lateral-sticky--visible');
    if (lateralSticky.classList.contains('au-lateral-sticky--visible')) {
      lateralStickyIcon.textContent = 'close';

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id: `sticky lateral_${lateralStickyLabel}`,
      });
    } else {
      lateralStickyIcon.textContent = 'phone';

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id: `sticky lateral_cerrar`,
      });
    }

    // toggle attributes aria-hidden and aria-expanded
    const expanded = lateralStickyButton.getAttribute('aria-expanded') === 'true';
    lateralStickyButton.setAttribute('aria-expanded', String(!expanded));
  }
}

function addEventListeners() {
  $('[data-au-lateral-sticky-button]').addEventListener('click', toggleLateralSticky);
  document.addEventListener('keyup', toggleLateralSticky);
  window.addEventListener('load', checkVisibilityLateralSticky);
  window.addEventListener('resize', checkVisibilityLateralSticky);
  window.addEventListener('scroll', checkVisibilityLateralSticky);
}

export default { init };
